import { decode } from "he";
import { html } from "htm/preact/index.js";
import { useAppContext } from "src/services/context";
import { useComputed } from "@preact/signals";
import Button from "src/modules/reservations/components/button/button";
import SvgIcon from "src/modules/reservations/components/svg-icon/svg-icon";

const deliveryKeys = [
  { key: "xdine_delivery", title: "Moxies" },
  { key: "doordash", title: "DoorDash" },
  { key: "grubhub", title: "GrubHub" },
  { key: "skip_the_dishes", title: "Skip The Dishes" },
  { key: "ubereats", title: "UberEats" },
];
/**
 * @typedef {object} OrderMenuProps
 * @prop {boolean} isVisible
 * @param {OrderMenuProps} props
 * @returns {import("preact").VNode}
 */
function OrderMenu(props) {
  const state = useAppContext();
  const selected = useComputed(() => {
    return state.restaurants.value.find((r) => {
      return r.id === Number(state.selectedOrderId.value);
    });
  });
  const deliveryOptions = useComputed(() => {
    const selectedAcf = selected.value?.acf ?? {};
    return deliveryKeys
      .map((k) => {
        return {
          id: k.key,
          url: selectedAcf[k.key],
          title: k.title,
        };
      })
      .filter((d) => !!d.url);
  });

  function handleChangeOrderLocation() {
    state.isLocationConfirmed.value = false;
  }

  return html` <div
    class="mx-reservation-form__step ${props.isVisible
      ? "mx-reservation-form__step--active"
      : ""}"
  >
    <header class="mx-reservation-form__header order-header">
      <div class="moxies-title">
        <small class="moxies-title__intro">
          <button
            onClick=${handleChangeOrderLocation}
            class="order-change-button"
          >
            Change location
          </button>
        </small>
        <h2 class=" elementor-size-default">
          <span class="">Moxies</span>
        </h2>
        <h2 class="elementor-heading-title elementor-size-default">
          <span class="copper-italic"
            >${selected.value && decode(selected.value?.title.rendered)}</span
          >
        </h2>
      </div>
      <p class="mx-reservation-form__address">
        ${selected.value?.acf.street_address}
      </p>
    </header>
    <div class="order-menus">
      <div>
        <h4
          class="elementor-heading-title elementor-size-default order-heading"
        >
          Order Pickup
          <${SvgIcon} icon="#icon-location" />
        </h4>
        <p>Using this location, place an order for pick-up.</p>
        <div class="order-delivery-buttons">
        ${(selected.value?.acf.doordash_pickup || selected.value?.acf.xdine)
            ? html`
                ${selected.value?.acf.doordash_pickup &&
                  html`<${Button}
                    href=${selected.value.acf.doordash_pickup}
                    icon="#icon-moxies"
                    size="lg"
                    tagName="a"
                    target="_blank"
                  >
                    Order Pick-Up
                  <//>`}
          
                ${selected.value?.acf.xdine &&
                  html`<${Button}
                    href=${selected.value.acf.xdine}
                    icon="#icon-moxies"
                    size="lg"
                    tagName="a"
                  >
                    Order Pick-Up
                  <//>`}
              `
            : html`<p class="mx-border-box">
                Pickup not available at this location.
              </p>`}
              </div>
          
      
      </div>
      <div>
        <h4
          class="elementor-heading-title elementor-size-default order-heading"
        >
          Order Delivery
          <${SvgIcon} icon="#icon-deliver" />
        </h4>
        <p>
          Using any of the delivery services, place an order to be delivered.
        </p>
        <div class="order-delivery-buttons">
          ${deliveryOptions.value.length === 0 &&
          html`<p class="mx-border-box">
            Delivery not available at this location.
          </p>`}
          ${deliveryOptions.value.map(
            (d) =>
              html`<${Button}
                key=${d.id}
                href=${d.url}
                icon="#icon-arrow"
                size="lg"
                tagName="a"
                style="outline"
              >
              ${d.title}
              <//>`
          )}
        </div>
      </div>
    </div>
  </div>`;
}

export default OrderMenu;
